import React, { useState, useEffect } from 'react';
import Link from 'next/link';
import { useSearchParams } from 'next/navigation';
import { Dialog } from '@headlessui/react';
import CrossIcon from "../../assets/svg/CrossIcon";
import MaticLogoBlack from "../../assets/svg/MaticLogoBlack";
import CopyIcon from "../../assets/svg/CopyIcon";
import useCart from "@/cart/useCart";
import { MATIC_REF_BOGO_DISCOUNT_CODE, MATIC_REFKIT_VARIANT_ID, MATIC_VARIANT_ID } from "@/consts/shopify";
import { isMainMatic, isRefKit } from '@/utils/ShopifyHelpers';
import { useRouter } from 'next/router';


const REFERRAL_POPUP_DISMISSED_KEY = 'customReferralPopupDismissed';
const VALID_CODES = ["FRIEND-ACC", "FRIEND-NOTION", "FRIEND-YC", "FRIEND-ABSTRACT", "FRIEND-NVIDIA"];

function CustomReferralPopup() {
  const searchParams = useSearchParams();
  const [isOpen, setIsOpen] = useState(false);
  const [copied, setCopied] = useState(false);
  const [code, setCode] = useState(null);
  const [amount, setAmount] = useState(null);
  const router = useRouter();
  const { addDiscountCode, addItem, initializeCart } = useCart();

  const addItemsChain = async (code) => {
    const fullCode = code.startsWith("FRIEND-") ? code : "FRIEND-" + code.toUpperCase();
    const newCart = await addDiscountCode(fullCode);
  }

  useEffect(() => {
    const code = searchParams.get('utm_term');

    const isAnyModalOpen = document.querySelector('[data-headlessui-state="open"]') !== null;
    const isValidReferralCode = code && (code.length === 7 || VALID_CODES.includes(code));

    if (code && !isAnyModalOpen && isValidReferralCode) {
      setCode(code.toUpperCase());
      setIsOpen(true);
      setAmount(30);
      addItemsChain(code);
    } else {
      setIsOpen(false);
    }
    
    const openHandler = (e) => {
      // If a code is passed via event detail, prefer it; otherwise reuse existing state
      const passedCode = e?.detail?.code;
      if (passedCode && typeof passedCode === 'string') {
        setCode(passedCode.toUpperCase());
      }
      setIsOpen(true);
    };
    
    window.addEventListener('open-custom-referral-popup', openHandler);
    return () => {
      window.removeEventListener('open-custom-referral-popup', openHandler);
    };
  }, []);

  const handleClose = () => {
    setIsOpen(false);
    setCopied(false);

    try {
       localStorage.setItem(REFERRAL_POPUP_DISMISSED_KEY, 'true');
    } catch (error) {
        console.error("Failed to access localStorage:", error);
    }
  };

  const handleShopNow = async () => {
    addItem(MATIC_VARIANT_ID);
    handleClose();
    router.push("/cart");
  };

  if (!isOpen) {
    return null;
  }

  return (
    <Dialog open={isOpen} onClose={handleClose} className="relative z-50">
      <div className="fixed inset-0 bg-black/30" aria-hidden="true" />

      <div className="fixed inset-0 flex items-center justify-center p-4">
        <Dialog.Panel className="relative mx-auto w-full max-w-lg rounded-lg bg-[#fff] p-8 shadow-xl text-center flex flex-col items-center">
           <button
              onClick={handleClose}
              className="absolute top-4 right-4 text-gray-600 hover:text-black p-1 focus:outline-none"
              aria-label="Close popup"
            >
              <CrossIcon classes="w-6 h-6" strokeSize="1.5" />
            </button>

          <img src="/images/referral_image.png" alt="Referral Image" className="mb-2" />

             <div className="flex items-center justify-center mb-6 gap-2">
              <img src="/images/CircularCheckmark.svg" alt="Referral Image" className="w-5 h-5" /> 
              <p className="text-2xl text-black font-medium font-trimMono">
                REFERRAL REWARD APPLIED!
              </p>
             </div>

             <p className="text-2xl text-black mb-6">
              A free 6-9 month supply of HEPA bags has been added to your cart.
             </p>
              <div className="w-full mt-2">
                <button
                  className="btn-secondary eyebrow-bold transition-colors rounded-full w-full block"
                  onClick={handleShopNow}
                >
                  Order Now
                </button>
              </div>
        </Dialog.Panel>
      </div>
    </Dialog>
  );
}

export default CustomReferralPopup; 